// extracted by mini-css-extract-plugin
export var buttons = "index-module--buttons--a8a51";
export var modalFooter = "index-module--modalFooter--358be";